import { useState, useEffect } from "react";
import { API_URL } from "src/util/config";
import { checkResponse } from "src/util/helpers";
import { JournalApprovalRequest } from "models/journal-approval";
import { useAuth } from "src/contexts/AuthContext";

export const useJournalApprovalRequests = () => {
  const [requests, setRequests] = useState<JournalApprovalRequest[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const { fetchWithReauth } = useAuth();

  const fetchByMonth = async (yearMonth?: string) => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams();
      if (yearMonth) {
        queryParams.append("yearMonth", yearMonth);
      }
      const response = await fetchWithReauth(
        `${API_URL}/journal-approvals?${queryParams.toString()}`,
        { method: "GET" }
      );
      const data = await checkResponse(response);
      setRequests(data.items);
    } catch (error) {
      console.error("Error fetching journal approval requests:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchByMonth();
  }, []);

  return {
    requests,
    loading,
    fetchByMonth,
  };
};
